<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Dados Restritos</h2>
          <p class="text-muted">
            Valores bloqueados na verificação antifraude da loja (e-mails, documentos e telefones).
          </p>
        </b-col>
      </b-row>

      <b-row align-h="between">
        <b-col lg="5">
          <b-form-group label-align="left" label-for="filterInput" label="Pesquisar valor:">
            <b-input-group>
              <b-form-input
                @input="updateFilter('search', $event)"
                :value="filters.search"
                type="search"
                id="filterInput"
                size="sm"
                placeholder="Formatado ou não, tanto faz"
              ></b-form-input>
              <b-input-group-append>
                <b-button size="sm" :disabled="!filters.search" @click="updateFilter('search', '')">Limpar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col lg="3">
          <b-form-group label-align="left" label="Tipo:">
            <b-form-select
              size="sm"
              :options="filterTypeOptions"
              :value="filters.type"
              @change="updateFilter('type', $event)"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col lg="2">
          <label for="filter-limit">Quantidade:</label>
          <b-form-input
            id="filter-limit"
            size="sm"
            type="number"
            min="1"
            @input="updateFilter('limit', $event)"
            :value="filters.limit"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button class="mr-1 mb-3" variant="info" @click="resetFilter">Limpar filtros</b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" v-if="appliedFilters.length > 0" class="mt-2 mb-4">
          <b-card no-body>
            <b-list-group flush>
              <b-list-group-item v-for="(item, index) in appliedFilters" :key="index">
                <strong>{{ item.filter }}:</strong> {{ item.values }}
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" class="mb-4">
          <h5>Adicionar à lista de bloqueio</h5>
          <b-form inline @submit.prevent="createRestriction">
            <b-form-select
              class="mr-2 mb-2"
              size="md"
              :options="createTypeOptions"
              v-model="newRestriction.type"
              required
            ></b-form-select>
            <b-form-input
              class="mr-2 mb-2"
              size="md"
              v-model="newRestriction.value"
              placeholder="Valor a bloquear"
              required
            ></b-form-input>
            <b-button size="md" variant="success" type="submit" class="mb-2" :disabled="creating">
              <icon name="plus" scale="0.9"></icon> Adicionar
            </b-button>
          </b-form>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" lg="5" class="mb-2">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" class="mt-2 mb-3" style="overflow-x: auto;">
          <b-table striped hover show-empty
            :items="restrictions"
            :fields="fields"
            primary-key="id"
            empty-filtered-text="Nenhum dado restrito encontrado"
            empty-text="Nenhum dado restrito encontrado"
          >
            <template v-slot:cell(type_label)="data">
              <span>
                <icon
                  v-if="data.item.is_automatic"
                  name="robot"
                  scale="0.9"
                  class="text-warning mr-1"
                  v-b-tooltip.hover
                  title="Inserido automaticamente pela loja"
                ></icon>
                {{ data.item.type_label }}
              </span>
            </template>

            <template v-slot:cell(user_name)="data">
              <span v-if="data.item.user_name">{{ data.item.user_name }}</span>
              <span v-else class="text-muted">Não cadastrado por esta tela</span>
            </template>

            <template v-slot:cell(actions)="data">
              <b-button size="sm" variant="danger" @click="deleteRestriction(data.item)" v-b-tooltip.hover title="Excluir">
                <icon name="trash" scale="0.9"></icon>
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import FilterStore from '@/filterStore'

export default {
  name: 'AdminDataRestrictions',
  data () {
    return {
      restrictions: [],
      appliedFilters: [],
      filterStore: null,
      currentPage: 1,
      totalRows: 0,
      perPage: 10,
      searchTimer: null,
      requestSeq: 0,
      creating: false,
      filters: {
        search: '',
        type: '',
        limit: 10
      },
      newRestriction: {
        type: '',
        value: ''
      },
      createTypeOptions: [
        { value: '', text: 'Selecione o tipo' },
        { value: 'email', text: 'E-mail' },
        { value: 'document', text: 'Documento' },
        { value: 'phone', text: 'Telefone' }
      ],
      filterTypeOptions: [
        { value: '', text: 'Todos os tipos' },
        { value: 'email', text: 'E-mail' },
        { value: 'document', text: 'Documento' },
        { value: 'phone', text: 'Telefone' },
        { value: 'general', text: 'Automático' }
      ],
      fields: [
        { key: 'value_formatted', label: 'Valor', class: ['align-middle'] },
        { key: 'type_label', label: 'Tipo', class: ['align-middle'] },
        { key: 'user_name', label: 'Cadastrado por', class: ['align-middle'] },
        { key: 'created_at', label: 'Data', class: ['align-middle', 'text-nowrap'], formatter: this.$options.filters.date },
        { key: 'actions', label: 'Ações', class: ['text-center', 'align-middle'] }
      ]
    }
  },
  created () {
    this.filterStore = new FilterStore(this.$session.get('login'), this.$route.path)
    this.filters = this.filterStore.merge(this.filters)
  },
  async mounted () {
    this.buildAppliedFilters()
    await this.loadRestrictions()
  },
  watch: {
    currentPage () {
      this.loadRestrictions()
    }
  },
  methods: {
    updateFilter (key, value) {
      this.filters[key] = value
      this.filterStore.save(key, value)
      this.buildAppliedFilters()
      this.currentPage = 1

      if (key === 'search') {
        clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(() => {
          this.loadRestrictions()
        }, 300)
        return
      }

      this.loadRestrictions()
    },
    buildAppliedFilters () {
      this.appliedFilters = []

      if (this.filters.search) {
        this.appliedFilters.push({ filter: 'Pesquisa', values: this.filters.search })
      }

      if (this.filters.type) {
        const option = this.filterTypeOptions.find(o => o.value === this.filters.type)
        this.appliedFilters.push({ filter: 'Tipo', values: option ? option.text : this.filters.type })
      }

      this.appliedFilters.push({ filter: 'Quantidade', values: String(this.filters.limit) })
    },
    resetFilter () {
      clearTimeout(this.searchTimer)
      this.filters = { search: '', type: '', limit: 10 }
      this.appliedFilters = []
      this.currentPage = 1
      this.filterStore.clear()
      this.loadRestrictions()
    },
    async loadRestrictions () {
      const params = ['page=' + this.currentPage]

      if (this.filters.search) {
        params.push('search=' + encodeURIComponent(this.filters.search))
      }
      if (this.filters.type) {
        params.push('type=' + encodeURIComponent(this.filters.type))
      }
      if (this.filters.limit) {
        params.push('limit=' + encodeURIComponent(this.filters.limit))
      }

      const url = process.env.VUE_APP_URL_APP + '/b/admin/data-restrictions?' + params.join('&')

      this.requestSeq += 1
      const seq = this.requestSeq

      try {
        const resp = await this.$http.get(url)

        if (seq !== this.requestSeq) {
          return
        }

        this.restrictions = resp.body
        this.currentPage = parseInt(resp.headers.get('x-page'))
        this.totalRows = parseInt(resp.headers.get('x-total-record'))
        this.perPage = parseInt(resp.headers.get('x-limit'))
      } catch (e) {
        if (seq !== this.requestSeq) {
          return
        }

        console.error(e)
        this.restrictions = []
        this.totalRows = 0

        const errorMessage = (e.body && e.body.message) || 'Erro ao carregar dados restritos'
        this.$bvToast.toast(errorMessage, {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    },
    async createRestriction () {
      if (this.creating || !this.newRestriction.type || !this.newRestriction.value) {
        return
      }

      this.creating = true

      try {
        const resp = await this.$http.post(process.env.VUE_APP_URL_APP + '/b/admin/data-restrictions', {
          value: this.newRestriction.value,
          type: this.newRestriction.type
        })

        this.$bvToast.toast('Dado restrito cadastrado com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })

        const created = resp.body
        this.newRestriction = { type: '', value: '' }
        this.currentPage = 1

        if (this.filters.type && this.filters.type !== created.type) {
          this.filters.type = ''
          this.filterStore.save('type', '')
        }

        if (this.filters.search && !created.value.includes(this.filters.search)) {
          this.filters.search = ''
          this.filterStore.save('search', '')
        }

        this.buildAppliedFilters()
        await this.loadRestrictions()
      } catch (e) {
        console.error(e)
        const errorMessage = (e.body && e.body.message) || 'Erro ao cadastrar dado restrito'
        this.$bvToast.toast(errorMessage, {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.creating = false
      }
    },
    async deleteRestriction (row) {
      let message = `Quer mesmo excluir "${row.value_formatted}" da lista de bloqueio?`
      if (row.duplicate_count > 1) {
        message += ` Este valor está cadastrado ${row.duplicate_count} vezes e todas serão removidas.`
      }

      const action = await this.$bvModal.msgBoxConfirm(message, {
        title: '⚠ Atenção',
        okVariant: 'danger',
        cancelVariant: 'secondary',
        okTitle: 'Excluir',
        cancelTitle: 'Cancelar',
        centered: true,
        hideHeaderClose: false
      })

      if (action === false || !action) {
        return
      }

      try {
        const resp = await this.$http.delete(process.env.VUE_APP_URL_APP + `/b/admin/data-restrictions/${row.id}`)

        this.$bvToast.toast(`${resp.body.deleted_count} registro(s) removido(s)`, {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })

        await this.loadRestrictions()
      } catch (e) {
        console.error(e)
        const errorMessage = (e.body && e.body.message) || 'Erro ao excluir dado restrito'
        this.$bvToast.toast(errorMessage, {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    }
  }
}
</script>
